import { useEffect } from "react";
import { uiStore } from "../uiStore";
import { TabellaRisorseClub } from "../tabellone/TabellaRisorseClub";

export function GestioneRisorse() {
  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => {
    setTitle("Gestione risorse/campi");
  }, [setTitle]);

  return (
    <>
      <TabellaRisorseClub />
    </>
  );
}
